module.exports = __webpack_public_path__ + "img/winter-img-loading.4e24672a.gif";